<style lang="scss">
  @use "../../../assets/css/design-system/utils";

  .attachments-container {
    gap: utils.in_rem(8px);

    .attachments {
      display: flex;
      flex-direction: row;
      gap: 1rem;
    }
  }
</style>

<script>
  import Attachment from "./Attachment.svelte";

  export let attachmentIds = [];
  import { attachmentsStore } from "../../../../src/svelte/api-stores/attachments-store";

  if (attachmentIds.length > 0) {
    attachmentsStore.once();
  }

  const ondelete = (attachmentId) => {
    attachmentIds = attachmentIds.filter((x) => x !== attachmentId);
  };
</script>

{#if attachmentIds.length > 0}
  <div class="attachments-container">
    <div class="attachments">
      {#each attachmentIds as attachmentId}
        <Attachment {attachmentId} {ondelete} />
      {/each}
    </div>
  </div>
{/if}
